/**
 * File Extensions
 */
export const FILE_EXTENSIONS = {
  JPG: 'jpg',
  WEBP: 'webp',
};
